import { Accordion } from 'flowbite-react';
const AiSecurityGovernanceFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                         What are the biggest security risks with AI systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            AI systems face risks such as data breaches, unauthorized access, adversarial attacks, bias, lack of audit trails, and model manipulation, which can lead to compliance violations, data leakage, and reputational damage.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you ensure our AI complies with GDPR and other regulations?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           We implement automated compliance checks, data encryption, consent management, and audit trails aligned with GDPR, HIPAA, and other standards to ensure lawful, transparent, and secure AI data processing.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can you detect bias in our existing ML models?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Yes, we use specialized tools and techniques to evaluate model performance across demographics, identify proxy bias, perform fairness assessments, and apply explainability methods to detect and mitigate bias in ML models.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you protect against prompt injection and jailbreak attacks?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We deploy threat detection frameworks, input validation, content filtering, and real-time monitoring to identify and block malicious prompts, preventing unauthorized model behavior and maintaining AI system integrity.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       What audit trails do we need for AI governance?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Audit trails should capture model training data, versioning, decision logs, access records, compliance checks, and incident reports to support transparency, accountability, and regulatory compliance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       How long does an AI security assessment take?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Typically, an AI security assessment takes 4 to 6 weeks, depending on system complexity, scope, data volume, and organizational readiness for audit and remediation activities.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Can you help with EU AI Act compliance?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Yes, we guide organizations through EU AI Act requirements by implementing risk classification, governance frameworks, transparency measures, documentation, and ongoing compliance monitoring.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you handle data privacy in LLM and RAG systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We enforce strict data encryption, anonymization, access controls, and secure API integrations to protect sensitive data processed by LLMs and Retrieval-Augmented Generation systems while ensuring compliance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What&apos;s the difference between AI security and traditional cybersecurity?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           AI security focuses on safeguarding AI models, data, and outputs from unique threats like model poisoning and bias, while traditional cybersecurity protects general IT assets from malware, intrusions, and data breaches.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you monitor AI systems for ongoing compliance?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Continuous monitoring uses logging, anomaly detection, bias tracking, and automated compliance reporting to ensure AI systems adhere to policies, regulations, and ethical standards throughout their lifecycle.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default AiSecurityGovernanceFAQ;
